import React from 'react'
import { Navigate } from 'react-router-dom'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'
import routePath from 'router/routePath'

type FeedbackGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

export const FeedbackGate: React.FC<FeedbackGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { contractTerminationOnly, defectNotice } = useModuleConfig()
  const enabled =
    !contractTerminationOnly &&
    defectNotice.enabled === true &&
    !defectNotice.customDefectNoticeLinkUrl &&
    defectNotice.feedback === true

  return enabled ? children : <Navigate to={redirectTo} replace />
}
